var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.name)?_c('span',{staticClass:"badge-site",style:({ background: _vm.colors.bg, color: _vm.colors.color })},[_c('span',{staticClass:"badge-dot",style:({ background: _vm.colors.dot })}),_vm._v(" "+_vm._s(_vm.name)+" ")]):_c('span',{staticClass:"badge-empty"},[_vm._v("—")])
}
var staticRenderFns = []

export { render, staticRenderFns }